module.exports = __webpack_public_path__ + "static/image/main/pc/banner-8.ver2_0_2.jpg?56dd3c33";